<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <h5>{{ show_name }} Vehicle</h5>
        <hr />
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="status_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                :class="{ 'p-invalid': submitted && !status_dropdownItem }"
              >
              </Dropdown>
              <label for="status">Status</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <InputText
                id="registration_number"
                type="text"
                v-model="product.registration_number"
                :class="{
                  'p-invalid': submitted && !product.registration_number,
                }"
              />
              <label for="registration_number">Registration No.</label>
            </span>
          </div>
          <!-- 
                    <div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText type="number" id="mobile_number_rc" v-model="product.mobile_number_rc"
                                :class="{ 'p-invalid': submitted && !product.mobile_number_rc }" />
                            <label for="mobile_number_rc">Mobile No Connected to Rc</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="rc_number" type="text" v-model="product.rc_number"
                                :class="{ 'p-invalid': submitted && !product.rc_number }" />
                            <label for="rc_number">Rc No.</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="model" type="text" v-model="product.model"
                                :class="{ 'p-invalid': submitted && !product.model }" />
                            <label for="model">Model</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="color" type="text" v-model="product.color"
                                :class="{ 'p-invalid': submitted && !product.color }" />
                            <label for="color">Enter Vehicle Color</label>
                        </span>
                     </div>  -->
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="dropdownItem"
                :options="dropdownItems"
                optionLabel="name"
                :class="{ 'p-invalid': submitted && !dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">Vehicle Type</label>
            </span>
          </div>
          <!-- <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <InputText
                id="fuel_type"
                type="text"
                v-model="product.fuel_type"
                :class="{ 'p-invalid': submitted && !product.fuel_type }"
              />
              <label for="fuel_type">Fuel Type</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Calendar
                inputId="make_year"
                v-model="product.make_year"
                view="year"
                dateFormat="yy"
                :class="{ 'p-invalid': submitted && !product.make_year }"
              />
              <label for="make_year">Make Year</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Calendar
                inputId="fitness_validity"
                v-model="product.fitness_validity"
                dateFormat="yy-mm-dd"
                :class="{ 'p-invalid': submitted && !product.fitness_validity }"
              />
              <label for="fitness_validity">Fitness Validity</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Calendar
                inputId="puc_validity"
                v-model="product.puc_validity"
                dateFormat="yy-mm-dd"
                :class="{ 'p-invalid': submitted && !product.puc_validity }"
              />
              <label for="puc_validity">PUC Validity</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Calendar
                inputId="insurance_validity"
                v-model="product.insurance_validity"
                dateFormat="yy-mm-dd"
                :class="{
                  'p-invalid': submitted && !product.insurance_validity,
                }"
              />
              <label for="insurance_validity">Insurance Validity</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <InputText
                id="bcnt"
                type="text"
                v-model="product.bcnt"
                :class="{ 'p-invalid': submitted && !product.bcnt }"
              />
              <label for="bcnt">Base City Name Of Tranportation</label>
            </span>
          </div> -->
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="district_dropdownItem"
                :options="district_dropdownItems"
                optionLabel="name"
                @change="get_block_master"
                :class="{ 'p-invalid': submitted && !district_dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">District</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="block_dropdownItem"
                :options="block_dropdownItems"
                @change="get_village_master('',2)"
                optionLabel="name"
                :class="{ 'p-invalid': submitted && !block_dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">Block</label>
            </span>
          </div>
          <div class="field col-12 md:col-6" style="margin-top: 1%">
            <span class="p-float-label">
              <Dropdown
                id="User"
                filter
                v-model="village_dropdownItem"
                :options="village_dropdownItems"
                @filter="get_village_master"
                optionLabel="name"
                :class="{ 'p-invalid': submitted && !village_dropdownItem }"
              >
              </Dropdown>
              <label for="vehicle_type">Village</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 1%">
            <h5>Document(Photo)</h5>
            <FileUpload
              v-tooltip.bottom="'Upload Photo'"
              mode="basic"
              id="file_attachment"
              ref="file_attachment"
              @change="handleFileUpload"
              name="demo[]"
              accept="application/pdf,image/jpeg,image/png"
              :maxFileSize="10000000"
            />
          </div>
          <div class="field col-12 md:col-10" style="margin-top: 1%">
            <a
              v-if="this.product.photos && this.product.photos[0]"
              :href="this.product.photos[0]"
              ><b><u>view</u></b>
            </a>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 1%"></div>
          <div class="field col-12 md:col-2" style="margin-top: 1%">
            <Button
              v-if="product._id"
              label="Update"
              class="p-button-success mr-2"
              @click="Add_user"
              v-tooltip.bottom="'Update '"
            />
            <Button
              v-else
              label="Add"
              class="p-button-success mr-2"
              @click="Add_user"
              v-tooltip.bottom="'Add'"
            />
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 1%">
            <Button
              label="Reset"
              class="p-button-danger mr-2"
              v-tooltip.bottom="'Reset'"
              @click="reset_user"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import apis from "@/apis";
import axios from "axios";
import BreadcrumbService from "../service/BreadcrumbService";
export default {
  data() {
    return {
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      dropdownItems: [],
      dropdownItem: null,
      district_dropdownItems: [],
      district_dropdownItem: null,
      block_dropdownItems: [],
      block_dropdownItem: null,
      village_dropdownItems: [],
      village_dropdownItem: null,
      id: "",
      list: [],
      client_role_group: "",
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: { name: "Active", value: "Active" },
      show_name: "Add",
      state_dropdownItems: [
        { name: "Andhra Pradesh", value: "Andhra Pradesh" },
        { name: "Arunachal Pradesh", value: "Arunachal Pradesh" },
        { name: "Assam", value: "Assam" },
        { name: "Bihar", value: "Bihar" },
        { name: "Chhattisgarh", value: "Chhattisgarh" },
        { name: "Goa", value: "Goa" },
        { name: "Gujarat", value: "Gujarat" },
        { name: "Haryana", value: "Haryana" },
        { name: "Himachal Pradesh", value: "Himachal Pradesh" },
        { name: "Jharkhand", value: "Jharkhand" },
        { name: "Karnataka", value: "Karnataka" },
        { name: "Kerala", value: "Kerala" },
        { name: "Madhya Pradesh", value: "Madhya Pradesh" },
        { name: "Maharashtra", value: "Maharashtra" },
        { name: "Manipur", value: "Manipur" },
        { name: "Meghalaya", value: "Meghalaya" },
        { name: "Mizoram", value: "Mizoram" },
        { name: "Nagaland", value: "Nagaland" },
        { name: "Odisha", value: "Odisha" },
        { name: "Punjab", value: "Punjab" },
        { name: "Rajasthan", value: "Rajasthan" },
        { name: "Sikkim", value: "Sikkim" },
        { name: "Tamil Nadu", value: "Tamil Nadu" },
        { name: "Telangana", value: "Telangana" },
        { name: "Tripura", value: "Tripura" },
        { name: "Uttar Pradesh", value: "Uttar Pradesh" },
        { name: "Uttarakhand", value: "Uttarakhand" },
        { name: "West Bengal", value: "West Bengal" },
      ],
      state_dropdownItem: null,
      product: {},
      submitted: false,
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  methods: {
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return year + "-" + month + "-" + date;
          }
        }
      } else {
        return "";
      }
    },
    handleFileUpload() {
      this.file_attachment = "";
      this.file_attachment = this.$refs.file_attachment.files[0];
      this.product.photos = [];
      // alert(this.file_attachment);
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async Add_user() {
      this.submitted = true;
      if (!this.status_dropdownItem.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.product.registration_number) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter  Registration no.",
          life: 3000,
        });
        return false;
      }
    //   if (!this.product.mobile_number_rc) {
    //     this.$toast.add({
    //       severity: "error",
    //       summary: "error",
    //       detail: "Please Enter  Mobile No",
    //       life: 3000,
    //     });
    //     return false;
    //   }
      // if (!this.product.rc_number) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Rc Number",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.make) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Make",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.model) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Model",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.color) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Vehicle Color",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (this.dropdownItem.value=='  ') {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Vehicle Type",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.fuel_type) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Fuel Type",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.make_year) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Make Year",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.fitness_validity) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Fitness Validity",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.puc_validity) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter PUC Validity",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.insurance_validity) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Insurance Validity",
      //     life: 3000,
      //   });
      //   return false;
      // }
      // if (!this.product.bcnt) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Base City Name Of Tranportation",
      //     life: 3000,
      //   });
      //   return false;
      // }
      this.product.vehicle_type = this.dropdownItem.value;
      // this.product.district=this.district_dropdownItem.value;
      // this.product.block=this.block_dropdownItem.value;
      // this.product.village=this.village_dropdownItem.value;
      var url = [];
      var file = this.file_attachment;
      console.log(file);
      if (file.name && file.type) {
        url.push(
          "https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" + file.name
        );
        var file_data = {
          filePath: file.name,
          contentType: file.type,
        };
        var promise2 = apis.uploadFile(file_data);
        promise2.then((response_api) => {
          axios
            .put(response_api.data.data, file, {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": file.type,
              },
            })
            .then((response) => {})
            .catch((error) => {
              this.$swal("error to upload file");
            });
        });
      } else {
        if (this.product.photos && this.product.photos[0]) {
          url = this.product.photos[0];
        }
      }
      //===========================================================================================
      var district_id = "";
      var district_name = "";
      var block_id = "";
      var block_name = "";
      var village_id = "";
      var village_name = "";
      var panchayat_id = "";
      var panchayat_name = "";
      var district_dropdownItem = this.district_dropdownItem;
      if (
        district_dropdownItem &&
        district_dropdownItem.value != null &&
        district_dropdownItem.name != null
      ) {
        district_id = district_dropdownItem.value;
        district_name = district_dropdownItem.name;
      }
      var block_dropdownItem = this.block_dropdownItem;
      if (
        block_dropdownItem &&
        block_dropdownItem.value != null &&
        block_dropdownItem.name != null
      ) {
        block_id = block_dropdownItem.value;
        block_name = block_dropdownItem.name;
      }
      var panchayat_dropdownItem = this.panchayat_dropdownItem;
      if (
        panchayat_dropdownItem &&
        panchayat_dropdownItem.value != null &&
        panchayat_dropdownItem.name != null
      ) {
        panchayat_id = panchayat_dropdownItem.value;
        panchayat_name = panchayat_dropdownItem.name;
      }
      var village_dropdownItem = this.village_dropdownItem;
      if (
        village_dropdownItem &&
        village_dropdownItem.value != null &&
        village_dropdownItem.name != null
      ) {
        village_id = village_dropdownItem.value;
        village_name = village_dropdownItem.name;
      }
      //===========================================================================================
      if (this.product._id) {
        var data1 = {
          _id: this.product._id,
          status: this.status_dropdownItem.value,
          registration_number: this.product.registration_number,
          mobile_number_rc: this.product.mobile_number_rc,
          rc_number: this.product.rc_number,
          make: this.product.make,
          model: this.product.model,
          color: this.product.color,
          vehicle_type: this.product.vehicle_type,
          fuel_type: this.product.fuel_type,
          make_year: this.convert_to_year(this.product.make_year),
          fitness_validity: this.dateFormatYMD(this.product.fitness_validity),
          puc_validity: this.dateFormatYMD(this.product.puc_validity),
          insurance_validity: this.dateFormatYMD(
            this.product.insurance_validity
          ),
          bcnt: this.product.bcnt,
          owner_id: this.id,
          updated_at: "",
          updated_by: this.id,
          client_id: this.product.client_id,
          photo: url,
          // "district":this.product.district,
          // "block":this.product.block,
          // "village":this.product.village,
          district_id: district_id,
          block_id: block_id,
          village_id: village_id,
          district_name: district_name,
          block_name: block_name,
          village_name: village_name,
          panchayat_id: panchayat_id,
          panchayat_name: panchayat_name,
        };
        this.isLoadingModel = true;
        var promise = apis.editvehicle(data1);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.reset_user();
            this.$router.push({ name: "vehiclemaster" });
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.$swal.fire(error.response.data);
          });
      }
      // else {
      //     var data = {
      //         "status": this.status_dropdownItem.value,
      //         "registration_number": this.product.registration_number,
      //         "mobile_number_rc": this.product.mobile_number_rc,
      //         "rc_number": this.product.rc_number,
      //         "make": this.product.make,
      //         "model": this.product.model,
      //         "color":this.product.color,
      //         "vehicle_type": this.product.vehicle_type,
      //         "fuel_type":this.product.fuel_type,
      //         "make_year":this.product.make_year,
      //         "fitness_validity":this.dateFormatYMD(this.product.fitness_validity),
      //         "puc_validity":this.dateFormatYMD(this.product.puc_validity),
      //         "insurance_validity":this.dateFormatYMD(this.product.insurance_validity),
      //         "bcnt":this.product.bcnt,
      //         "owner_id":this.id,
      //         "created_at": "",
      //         "created_by": this.id,
      //         "client_id":localStorage.getItem("client_id")?localStorage.getItem("client_id"):'',
      //         "photo":url,
      //     };
      //     this.isLoadingModel = true;
      //     var promise1 =  apis.addvehicle(data);
      //     promise1
      //         .then((responseapi) => {
      //             this.$swal(responseapi.data.message);
      //             this.isLoadingModel = false;
      //             this.reset_user();
      //             this.$router.push({ name: "vehiclemaster" });
      //         })
      //         .catch((error) => {
      //             //console.log(error);
      //             this.isLoadingModel = false;
      //             this.$swal.fire(error.response.data);
      //         });
      // }
    },
    convert_to_year(data) {
      //const dateString = data;
      const date = new Date(data);
      const year = date.getFullYear();
      return year.toString();
    },
    get_vehicle_type_master() {
      const client_group_ids = localStorage.getItem("client_group_ids")
        ? JSON.parse(localStorage.getItem("client_group_ids"))
        : [];
      this.loading = true;
      var data = {
        client_id: localStorage.getItem("client_id"),
        client_group_ids: client_group_ids,
      };
      var promise = apis.vehicle_type_master(data);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].name,
            });
          }
          this.dropdownItems = temp_data;
        }
      });
    },
    get_district_master() {
      const client_group_ids = localStorage.getItem("client_group_ids")
        ? JSON.parse(localStorage.getItem("client_group_ids"))
        : [];
      this.loading = true;
      var data = {
        client_id: localStorage.getItem("client_id"),
        client_group_ids: client_group_ids,
        count: false,
        service_name: this.service_name,
      };
      var promise = apis.getStateData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          for (let x = 0; x < response.data.data.length; x++) {
            this.district_dropdownItems.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
        }
      });
    },
    get_block_master() {
      this.block_dropdownItems=[];
      var district_code = [];
      if (this.district_dropdownItem) {
        district_code.push(this.district_dropdownItem.value);
      }
      this.loading = true;
      var data = {
        count: false,
        district_code: district_code,
      };
      var promise = apis.getBlockData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          //var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            this.block_dropdownItems.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.block_dropdownItems = temp_data;
        }
      });
    },
    get_village_master(search,flag) {
      var district_code = [];
      var block_code = [];
      if (this.district_dropdownItem) {
        district_code.push(this.district_dropdownItem.value);
      }
      if (this.block_dropdownItem) {
        block_code.push(this.block_dropdownItem.value);
      }
      this.loading = true;
      var data = {
        //client_id:localStorage.getItem("client_id"),
        count: false,
        service_name: this.service_name,
        search_name: flag==2?'a':search.value,
        district_code: district_code,
        block_code: block_code,
      };
      var promise = apis.getVillageData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          //var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            this.village_dropdownItems.push({
              name: response.data.data[x].village_name,
              value: response.data.data[x].village_code,
            });
          }
          //this.village_dropdownItems = temp_data;
        }
      });
    },
    reset_user() {
      this.product = {};
      this.submitted = false;
      this.status_dropdownItem = null;
      this.dropdownItem = null;
      this.state_dropdownItem = null;
      this.location_search = "";
      this.$refs.file_attachment.files = "";
      this.show_name = "Add";
    },
  },
  async created() {
    this.productService = new ProductService();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.vehicle_edit();
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
    this.id = localStorage.getItem("id");
    if (localStorage.getItem("savevehicledata")) {
      this.product = await JSON.parse(localStorage.getItem("savevehicledata"));
      this.status_dropdownItem = {};
      this.status_dropdownItem.value = await this.product.status;
      this.status_dropdownItem.name = await this.product.status;
      if (this.product.vehicle_type) {
        this.dropdownItem = {};
        this.dropdownItem.value = await this.product.vehicle_type;
        this.dropdownItem.name = await this.product.vehicle_type;
      }
      if (this.product.district_id && this.product.district_name) {
        this.district_dropdownItem = {};
        this.district_dropdownItem.value = await this.product.district_id;
        this.district_dropdownItem.name = await this.product.district_name;
      }
      if (this.product.block_id && this.product.block_name) {
        this.block_dropdownItem = {};
        this.block_dropdownItem.value = await this.product.block_id;
        this.block_dropdownItem.name = await this.product.block_name;
      }
      if (this.product.village_id) {
        this.village_dropdownItem = {};
        this.village_dropdownItem.value = await this.product.village_id;
        this.village_dropdownItem.name = await this.product.village_name;
        var search = { value: this.village_dropdownItem.name };
        await this.get_village_master(search);
      }
      this.show_name = "Update";
    }
    this.get_district_master();
    this.get_block_master(this.product.block);
    this.get_vehicle_type_master();
    //await this.get_village_master(this.product.village);
    await localStorage.setItem("savevehicledata", "");
  },
  components: { downloadExcel: JsonExcel },
};
</script>
